export const FETCH_PROJECTS = "FETCH_PROJECTS";
export const FETCH_PROJECTS_PENDING = "FETCH_PROJECTS_PENDING";
export const FETCH_PROJECTS_REJECTED = "FETCH_PROJECTS_REJECTED";
export const FETCH_PROJECTS_FULFILLED = "FETCH_PROJECTS_FULFILLED";
export const SET_ACTIVE_PROJECT_ID = "SET_ACTIVE_PROJECT_ID";
export const SET_ACTIVE_VECTOR_ID = "SET_ACTIVE_VECTOR_ID";